"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgPercentageCircle(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 0c6.626 0 12 5.374 12 12 0 6.628-5.373 12-12 12-6.628 0-12-5.372-12-12C0 5.373 5.372 0 12 0zm0 1.532C6.218 1.532 1.532 6.219 1.532 12c0 5.782 4.686 10.468 10.468 10.468 5.78 0 10.468-4.686 10.468-10.468C22.468 6.22 17.78 1.532 12 1.532zm2.76 10.103c1.16 0 1.892.882 1.892 1.941v.02c0 1.06-.762 1.942-1.892 1.942-1.129 0-1.891-.882-1.891-1.942v-.02c0-1.06.733-1.941 1.891-1.941zm1.06-3.14L12.7 12.31l-2.506 3.12H8.7l3.06-3.735 2.566-3.199h1.495zm-1.06 4.398c-.287 0-.515.257-.515.683v.02c0 .416.258.684.515.684.258 0 .515-.258.515-.684v-.02c0-.416-.237-.683-.515-.683zM9.758 8.386c1.16 0 1.892.882 1.892 1.942v.02c0 1.06-.762 1.94-1.892 1.94-1.129 0-1.891-.88-1.891-1.94v-.02c0-1.06.733-1.942 1.891-1.942zm0 1.258c-.287 0-.515.258-.515.684v.02c0 .415.258.683.515.683.258 0 .516-.258.516-.684v-.02c0-.415-.238-.683-.516-.683z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgPercentageCircle;
exports.default = _default;